<template>
  <div class="login-View" :style="{background:'url('+url+')'}">
    <div
      class="login-box"
      v-loading="loading"
      element-loading-text="正在登陆,请稍等..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="logoImage"></div>
      <div class="login-form">
        <div class="login-form-title">
          <div>虹口区老干部服务中心</div>
          <div>服务信息管理系统</div>
        </div>
        <div class="wrapper">
          <el-form
            id="loginform"
            ref="loginform"
            :model="ruleForm"
            :rules="rules"
          >
            <el-form-item label="" prop="username">
              <el-input
                v-model="ruleForm.username"
                prefix-icon="el-icon-user-solid"
                type="text"
                maxlength="10"
                placeholder="请输入账号"
                autocomplete="off"
                size="medium"
                show-word-limit
                clearable
              >
              </el-input>
            </el-form-item>

            <el-form-item label="" prop="password">
              <el-input
                v-model="ruleForm.password"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
                maxlength="10"
                size="medium"
                show-password
                show-word-limit
                clearable
                @keydown.native.enter="submitForm('loginform')"
              ></el-input>
            </el-form-item>

            <el-form-item label="">
              <el-button
                type="primary"
                plain
                style="width: 100%"
                @click="submitForm('loginform')"
                ><span>登录</span>
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>



<script>

import { sm4 } from "sm-crypto";
import defaultSettings from "@/settings";
const { SMkey } = defaultSettings;
// let encryptData = sm4.encrypt(msg, key) // 加密，默认输出 16 进制字符串，默认使用 pkcs#5 填充
// let encryptData = sm4.encrypt(msg, key, {padding: 'none'}) // 加密，不使用 padding
// let encryptData = sm4.encrypt(msg, key, {padding: 'none', output: 'array'}) // 加密，不使用 padding，输出为字节数组
// let encryptData = sm4.encrypt(msg, key, {mode: 'cbc', iv: 'fedcba98765432100123456789abcdef'}) // 加密，cbc 模式

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      url:require('@/assets/img/bg2.png'),
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "账号不能为空",
            trigger: "blur",
          },
          {
            min: 5,
            max: 10,
            message: "长度5-10位",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur",
          },
          {
            min: 5,
            max: 10,
            message: "长度5-10位",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 表单验证通过，
          // sm4对账号和密码进行加密
          let _username = sm4.encrypt(this.ruleForm.username, SMkey);
          let _password = sm4.encrypt(this.ruleForm.password, SMkey);
          // console.log(_username + " === " + _password);
          // let _username = this.ruleForm.username;
          // let _password = this.ruleForm.password;
          // 调用后端接口进行登录验证
          this.loading = true;
          this.login({ username: _username, password: _password });
          this.loading = false;
        } else {
          // 表单验证不通过
          this.$message.error("登录名或者密码不符合要求");
        }
      });
    },

    login(loginParam) {
      this.$axios
        .post("/login", loginParam)
        .then((response) => {
          //获取到用户信息和token
          const { data } = response;
          if (data.code != "200") {
            this.$message.error(data.message);
            return;
          }

          if (!data.obj) {
            this.$message.error("返回的数据格式不正确");
            return;
          }

          // 获取token并存储
          const { token, user } = data.obj;
          if (token) {
            this.loading = false;
            this.$store.commit("user/SET_TOKEN", token);
            this.$store.commit("user/SET_USERINFO", user);
            this.$store.commit("user/SET_MENUS", []);
            this.$router.push("/layout");
          } else {
            this.$message.error("未能正确返回token");
          }
        })
        .catch((error) => {
          this.$message.error("用户名密码错误！");
        });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

  },
};
</script>


<style lang="scss">
$mainColor: #2aacb2;
.login-View {
  width: 100%;
  height: 100%;
  background: $mainColor;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: normal;
  .login-box {
    width: 800px;
    height: 400px;
    background: white;
    box-shadow: 0 0 10px #cdc4c4;
    display: flex;
    box-sizing: border-box;
    padding: 20px;

    .logoImage {
      flex: 1;
      overflow: hidden;
      position: relative;
      &::after {
        position: absolute;
        content: " ";
        width: 100%;
        height: 100%;
        left: -50%;
        border-radius: 50%;
        background: radial-gradient(#2aacb285 15%, #2aacb2 60%);
        transform: scale(2);
      }
    }

    .login-form {
      width: 400px;
      height: 100%;
      padding: 10px 20px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;

      .login-form-title {
        font-size: 24px;
        font-weight: 600;
        height: 80px;
        text-align: center;
        // text-shadow: 0 1px white;
      }

      .wrapper {
        margin-top: 20px;
        height: auto;
        .el-input {
          margin-bottom: 20px;
          .el-input__inner {
            border: none;
            border-radius: 0;
            border-bottom: 1px solid #88888840;
            padding-left: 40px;

            &:focus {
              border-color: $mainColor;
            }
          }
          .el-input__icon {
            color: $mainColor;
            font-size: large;
          }
        }
        button {
          margin-top: 20px;
          width: 100%;
          background: $mainColor;
          color: white;
          font-weight: bolder;
          letter-spacing: 10px;
        }
      }
    }
  }
}
</style>
